import { ErrorHandler, inject, provideAppInitializer } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { environment } from '@nx-superprep/environment';

export function provideSentryProviders(platformId: object) {
  if (!environment.production || isPlatformServer(platformId)) {
    return []
  }
  return [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        logErrors: true,
        showDialog: false
      })
    },
    {
      provide: Sentry.TraceService,
      deps: [Router]
    },
    provideAppInitializer(() => {
      inject(Sentry.TraceService)
    }),
  ]
}

/*
export function provideSentryProviders() {
  return [
    {
      provide: 'sentryProviders',
      useFactory: provideSentryProviders,
      deps: [PLATFORM_ID]
    },
  ]
}
*/
